import { gql } from '@apollo/client'

const CREATE_CAMPAIGN = gql`
  mutation ($campaign: CreateCampaignInput!) {
    createCampaign(campaign: $campaign) {
      campaign {
        campaignId
      }
      error {
        code
        message
      }
    }
  }
`

export default CREATE_CAMPAIGN
